import { ENABLE_DEV_REV, isFeatureEnabled } from '/b2b/common/helpers/FeatureFlags';

import Component from './DevRev.component';
import { connect } from 'react-redux';
import fromState from '/b2b/common/state/selectors';

const mapStateToProps = state => {
    const customerId = fromState.Auth.customer.getId(state);

    // TODO: Remove once Zendesk is replaced by DevRev
    const devRevEnabled = isFeatureEnabled(state, ENABLE_DEV_REV);

    const userId = fromState.Auth.user.getId(state);
    const user = fromState.DB.user.getEntityById(state, userId);
    const { devRevToken = '' } = user || {};

    return {
        customerId,
        devRevEnabled,
        devRevToken,
    };
};

export default connect(mapStateToProps)(Component);
